import React from 'react'
import { useTranslation } from 'react-i18next'
import { DataBlock } from '@fs/zion-ui'
import { css } from '@linaria/core'
import type { TfData } from '@fs/zion-tree-types'

const placeContainerCss = css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export default function AncestorEvent({ ancestorData }: { ancestorData: Pick<TfData, 'person'> }): JSX.Element {
  const [t] = useTranslation()
  const place =
    ancestorData.person.birthPlace ||
    ancestorData.person.christeningPlace ||
    ancestorData.person.deathPlace ||
    ancestorData.person.burialPlace
  const eventData = (
    <div className={placeContainerCss} data-testid="ancestor-event">
      {place?.address}
    </div>
  )

  let placeType = ''
  if (ancestorData.person.birthPlace) placeType = t('ancestor-card.birth.label')
  else if (ancestorData.person.christeningPlace) placeType = t('ancestor-card.christening.label')
  else if (ancestorData.person.deathPlace) placeType = t('ancestor-card.death.label')
  else if (ancestorData.person.burialPlace) placeType = t('ancestor-card.burial.label')

  return <>{place && <DataBlock heading={placeType} data={eventData} />}</>
}
